package features.uploadReceipt.internal

import kangaroorewards.appsdk.core.network.base.Endpoint

internal val UploadReceiptEndpoint = Endpoint(path = "users/me/businesses/{businessId}/scanned-receipts")